import { render } from "./vreportsinglecens.vue?vue&type=template&id=1f317d2f&scoped=true"
import script from "./vreportsinglecens.vue?vue&type=script&lang=js"
export * from "./vreportsinglecens.vue?vue&type=script&lang=js"

import "./vreportsinglecens.vue?vue&type=style&index=0&id=1f317d2f&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f317d2f"]])

export default __exports__